module.exports = __webpack_public_path__ + "73da176ef5fc3c460b899baf2932eb67.pdf";